'use client';

import { ReactComponent as Heart } from '@assets/icons/heart-circle-exclamation.svg';
import { ReactComponent as LocationArrow } from '@assets/icons/location-arrow.svg';
import { ReactComponent as LocationSlash } from '@assets/icons/location-dot-slash.svg';

import { Flex, useTheme } from '@chakra-ui/react';

import { LocationInfoType } from 'types';

import { Button, Text } from 'ui';

interface LocationInfoBannerProps {
  type: LocationInfoType;
  goBack: () => void;
}

const LocationInfoBanner = ({ type, goBack }: LocationInfoBannerProps) => {
  const {
    colors: {
      palette: {
        components: {
          locations: { infoBanner: styles }
        }
      }
    }
  } = useTheme();

  const getContent = () => {
    switch (type) {
      case LocationInfoType.NO_FAVORITE_LOCATION:
        return {
          title: 'You Do Not Have Any Favorite Locations',
          subTitle: 'TOGGLE THE HEART ICON NEXT TO A LOCATION NAME',
          Icon: Heart
        };
      case LocationInfoType.SERVICE_NOT_ACTIVATED:
        return {
          title: 'Please Activate Location Services and Try Again',
          subTitle: 'YOUR BROWSER DOESN’T HAVE LOCATION SERVICES ENABLED',
          Icon: LocationArrow
        };
      case LocationInfoType.NO_NEAREST_LOCATION:
        return {
          title: 'Sorry, No Locations Within 100 Miles',
          subTitle: 'Of Your Current Location',
          Icon: LocationSlash
        };

      default:
        return {
          title: '',
          subTitle: '',
          Icon: Heart
        };
    }
  };

  const { title, subTitle, Icon } = getContent();

  return (
    <Flex
      bg={styles.bg}
      justifyContent='center'
      alignItems='center'
      flexDirection='column'
      py={{ base: '25px', md: '35px' }}
      px='20px'
      maxW='900px'
      margin={{ base: 0, md: '0 auto' }}
      borderRadius='12px'
    >
      <Text
        fontSize={{ base: '20px', md: '24px', lg: '28px' }}
        color={styles.title}
        textAlign='center'
        fontWeight='semibold'
        mb={{ base: '35px', md: '8px' }}
      >
        {title}
      </Text>
      <Text
        fontSize={{ base: '12px', md: '14px', lg: '18px' }}
        px={{ base: '20px', md: 0 }}
        textAlign='center'
        fontWeight='regular'
        color={styles.subTitle}
        textTransform='uppercase'
      >
        {subTitle}
      </Text>
      <Flex
        justifyContent='center'
        my={{ base: '35px', md: '75px' }}
        sx={{
          '& > svg': {
            width: { base: '45px', md: '86px' },
            height: { base: '45px', md: '98px' }
          }
        }}
      >
        <Icon fill={styles.iconColor} />
      </Flex>
      <Button
        colorScheme='black'
        onClick={goBack}
        margin='0 auto'
        w='150px'
        padding={0}
      >
        Back
      </Button>
    </Flex>
  );
};

export default LocationInfoBanner;
